// This regex is used in Number Response item validation.
// If a string matches it, it contains a character that is
// disallowed from entry in that item type.
export const isNonNumericRegex = /[^0-9-.,/ ]/;
